import React, { useState } from 'react';
import { Lock } from 'lucide-react';
function AdminLoginModal({ isOpen, onClose, onLogin }) {
    const [key, setKey] = useState("");
    const SECRET_KEY = "ezems@admin2025";

    if (!isOpen) return null;

    const handleCheck = (e) => {
        e.preventDefault();
        if (key === SECRET_KEY) {
            onLogin(true);
            onClose();
            alert("Admin access enabled. Management tools unlocked.");
        } else {
            alert("Invalid administrative key.");
        }
    };

    return (
        <div className="fixed inset-0 z-[150] flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-slate-900/80 backdrop-blur-sm" onClick={onClose}></div>
            
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-xs p-6 relative z-10 animate-slide-up">
                <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
                    <Lock size={18}/> Admin Verification
                </h3>
                
                <form onSubmit={handleCheck}>
                    <input 
                        type="password" 
                        placeholder="Secret Key" 
                        className="w-full px-4 py-2 border rounded-lg mb-4 text-sm outline-none focus:ring-2 focus:ring-blue-500" 
                        value={key} 
                        onChange={e => setKey(e.target.value)}
                        autoFocus
                    />
                    
                    <div className="flex gap-2">
                        <button 
                            type="button" 
                            onClick={onClose} 
                            className="flex-1 py-2 text-sm font-bold text-slate-500"
                        >
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            className="flex-1 py-2 text-sm font-bold bg-slate-900 text-white rounded-lg"
                        >
                            Verify
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AdminLoginModal;